// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"2ec2255e","308":"fd2375f8","511":"abb7e358"}[chunkId] + ".chunk.js";
};